import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import {
  selectCategoryList,
  useGetCategoryListQuery,
} from "../../services/categoryApiSlice";

import { selectCategoryState, setCategory } from "../../store/categorySlice";
import { TablePage } from "./TablePage";

import classes from "./categoryPage.module.css";
import { CategoryPageSkeleton } from "../../component/skeleton/CategoryPageSkeleton";
import { toast } from "react-toastify";
import { FileUploadInput } from "../../component/fileUploadInput/FileUploadInput";
import { uploadImageRequest } from "../../http-request/uploadFile";
import { closeModal, openModal } from "../../store/modalSlice";
import { CustomTable } from "../../component/customTable/CustomTable";

export const CategoryPage = () => {
  const dispatch = useDispatch();

  const params = useParams();
  const [failedItems, setFailedItems] = useState([]);
  const category = params.category;
  const appliedFilters = useSelector(selectCategoryState);

  const { isSuccess, error } = useGetCategoryListQuery(appliedFilters, {
    skip: !appliedFilters.category,
  });
  const tableData = useSelector(selectCategoryList);

  useEffect(() => {
    dispatch(
      setCategory({
        category: category,
      })
    );
  }, [category, dispatch]);

  const handleFileChange = async (event) => {
    dispatch(
      openModal({
        component: "uploadModal",
        uiData: {
          heading: "Please wait a moment while we process it securely.",
        },
      })
    );

    const selectedFile = event.target.files[0];
    if (!selectedFile) return;

    const toastId = toast.loading("Uploading...");

    const result = await uploadImageRequest(selectedFile, category);

    // ❌ TRUE ERROR → current flow unchanged
    if (!result.success) {
      toast.update(toastId, {
        render: result.error,
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
      dispatch(closeModal());
      return;
    }

    // ✔️ FORMAT CORRECT → KEEP SAME FLOW
    if (result.code !== "414") {
      toast.update(toastId, {
        render: "File uploaded successfully!",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });

      setFailedItems([]); // clear previous failed rows if any
    }

    // ⚠️ FORMAT WRONG → SHOW WARNING + TABLE
    else {
      toast.update(toastId, {
        render: result.message || "Some rows failed to process",
        type: "warning",
        isLoading: false,
        autoClose: 3000,
      });

      setFailedItems(result.data); // show failed rows
    }

    event.target.value = null;
    dispatch(closeModal());
  };

  const handleDownloadSample = async () => {
    try {
      const downloadUrl = `https://aws-mg-new-bucket.s3.ap-south-1.amazonaws.com/mg_template_${category}_file.xlsx`;
      console.log(category);
      const anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.target = "_self";
      anchor.download = `mg_template_${category}_file.xlsx`;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    } catch (error) {
      console.error("Error downloading the sample file:", error);
      // Optionally, show a user-friendly message or toast notification
    }
  };

  return isSuccess ? (
    <div className={classes.box}>
      <div className={classes.box__btn}>
        <FileUploadInput id="image_url" onChange={(e) => handleFileChange(e)} />
        <button
          className={classes.box__details__download}
          onClick={handleDownloadSample}
        >
          <span className={classes.box__details__download__img}></span>
          Download Template
        </button>
      </div>

      <TablePage data={tableData} />
      {failedItems.length > 0 && (
        <div className={classes.modal}>
          <div className={classes.modal__content}>
            <div className={classes.modal__content__head}>
              <h1 className={classes.modal__content__head__title}>
                List of mismatched items:
              </h1>
              <button
                className={classes.modal__close}
                onClick={() => setFailedItems([])}
              >
                Close
              </button>
            </div>
            <CustomTable
              data={failedItems}
              header
              columns={[
                { accessorKey: "row_no", header: "Row" },
                { accessorKey: "brand", header: "Brand" },
                { accessorKey: "model", header: "Model" },
                { accessorKey: "part_name", header: "Part Name" },
                { accessorKey: "color", header: "Color" },
              ]}
            />
          </div>
        </div>
      )}
    </div>
  ) : (
    <CategoryPageSkeleton />
  );
};
